import { Injectable } from '@angular/core';

import type {
  ImageMenuCallbacks,
  ImageMenuData,
  ImageMenuController,
} from '@core/prosemirror-legacy';
import type { DialogRef } from '@core/user-interface-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { ImageDialogComponent } from './image-dialog/image-dialog.component';

@Injectable()
export class ImageMenuService implements ImageMenuController {
  private dialogRef: DialogRef<ImageDialogComponent> | null = null;

  constructor(private dialogSvc: DialogService) {}

  public get isCreateModeOpen() {
    return !!(this.dialogRef && this.dialogRef.componentInstance.mode === 'create');
  }

  public open(callbacks: ImageMenuCallbacks, data: Partial<ImageMenuData> = {}) {
    this.dialogRef = this.dialogSvc.openCustom(
      ImageDialogComponent,
      { width: DialogWidth.Large },
      { initData: data, callbacks },
    );
    this.dialogRef.afterClosed.subscribe(() => (this.dialogRef = null));
    return this.dialogRef;
  }

  public close() {
    this.dialogRef?.close();
  }
}
